import { createSvg } from '../createSvg';

const CartStroke = ({ strokeWidth = 1.5 }) => (
    <g id={'contour'}>
        <path
            d='M9.42871 18.179C9.83603 18.179 10.2266 18.3411 10.5146 18.6292C10.8027 18.9172 10.9648
                19.3077 10.9648 19.7151C10.9648 20.1223 10.8026 20.5131 10.5146 20.801C10.2266 21.0888
                9.83589 21.2502 9.42871 21.2502C9.02151 21.2501 8.63072 21.089 8.34277 20.801C8.05484
                20.5131 7.89363 20.1223 7.89355 19.7151C7.89355 19.3079 8.05495 18.9171 8.34277
                18.6292C8.63072 18.3412 9.02151 18.1791 9.42871 18.179ZM17.4297 18.179C17.837 18.179
                18.2276 18.3411 18.5156 18.6292C18.8036 18.9172 18.9658 19.3078 18.9658 19.7151C18.9657
                20.1223 18.8036 20.5131 18.5156 20.801C18.2276 21.089 17.837 21.2502 17.4297 21.2502C17.0224
                21.2502 16.6318 21.089 16.3438 20.801C16.0558 20.5131 15.8936 20.1223 15.8936 19.7151C15.8936
                19.3078 16.0558 18.9172 16.3438 18.6292C16.6318 18.3411 17.0223 18.179 17.4297 18.179ZM2.85742
                2.74927H3.49512C4.17769 2.74933 4.62899 3.19066 4.94531 3.7688H4.94629C5.15504 4.14976 5.31593
                4.61282 5.45215 5.07349L5.61816 5.63403L6.20215 5.6106L6.29395 5.60669H20.5703C21.0212 5.60669
                21.3464 6.03814 21.2227 6.47192L19.1338 13.7971C18.9911 14.2972 18.6895 14.7377 18.2744
                15.051C17.8593 15.3644 17.3531 15.5333 16.833 15.5334H10.0352C9.51085 15.5335 9.00093 15.3611
                8.58398 15.0432C8.16725 14.7255 7.86641 14.28 7.72754 13.7747L6.8584 10.6057L6.85645
                10.5989L6.85449 10.5911L5.43164 5.79321L5.41699 5.74146L5.28418 5.26489C5.16821 4.86073 5.03578
                4.44723 4.86426 4.08325L4.75684 3.87134C4.61193 3.60509 4.44259 3.37278 4.22363 3.20825C3.9768
                3.0228 3.72154 2.96411 3.49609 2.96411H2.85742C2.82899 2.96411 2.80135 2.95199 2.78125
                2.93188C2.76137 2.91186 2.75006 2.88492 2.75 2.85669C2.75 2.82826 2.76115 2.80062 2.78125
                2.78052C2.80135 2.76041 2.82899 2.74927 2.85742 2.74927Z'
            strokeWidth={strokeWidth}
        />
    </g>
);

export default createSvg(CartStroke, 'cart-stroke');
